import React from "react";
import { AgentProfile, AppPresence } from "@closerplatform/spinner-openapi";
import styles from "./adviserPickerItem.css";
import { Avatar } from "@fidget/common/components/avatar/avatar";
import { DotIndicator } from "@fidget/common/components/indicators/dotIndicator/dotIndicator";

export const AdviserPickerItem = ({ item: adviser }: { item: AgentProfile }) => {
  return (
    <div className={styles.entry}>
      <div className={styles["agent-avatar"]}>
        <Avatar user={adviser} />
      </div>
      {adviser.presence === AppPresence.Available && (
        <div className={styles.indicator}>
          <DotIndicator variant="presence" />
        </div>
      )}
      <div className={styles["agent-name"]}>
        {adviser.firstName} {adviser.lastName}
      </div>
    </div>
  );
};
